import { render, staticRenderFns } from "./TibBannerTimeInput.vue?vue&type=template&id=8a876436"
import script from "./TibBannerTimeInput.vue?vue&type=script&lang=js"
export * from "./TibBannerTimeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports